<template>
  <v-container fluid pa-0>
    <v-layout>
      <v-progress-circular
        v-if="this.$apollo.loading"
        indeterminate
        :width="2"
        :size="25"
      ></v-progress-circular>
    </v-layout>

    <v-layout v-if="extrasList.length > 0" wrap justify-start>
      <v-flex xs12>
        <h5 class="subheading">Available Extras</h5>
      </v-flex>
      <item-extras-list-item
        :key="extra.id + i"
        v-for="(extra, i) in extrasList"
        class="pb-2"
        :name="extra.name"
        :price="extra.sell"
        :currency="extra.currencySell"
        :rate-type="extra.rateTypeCode"
        :rate-base="extra.rateBase"
        :start-date="extra.startDate"
        :end-date="extra.endDate"
        :range-start="from"
        :range-end="to"
        :qty="extra.qty"
        :percent-price="extra.percentPrice"
        @select="onSelect"
        @deselect="onDeselect"
        :id="extra.id"
        :service-type="serviceType"
        :is-mandatory="extra.isMandatory"
        :is-selected="extra.isSelected"
        :is-child-only="extra.isChildOnly"
        :is-infant-only="extra.isInfantOnly"
        :max-pax="maxPax"
      ></item-extras-list-item>
    </v-layout>
    <div v-if="debug">
      <code>{{ selectedExtras }}</code>
    </div>
  </v-container>
</template>
<script>
import { GET_AVAILABLE_EXTRAS_QUERY } from "../../../../../constants/graphql";
import ItemExtrasListItem from "./ItemExtrasListItem";
import * as moment from "moment";
export default {
  name: "ItemExtrasList",
  props: {
    serviceId: {
      type: String,
      required: true,
    },
    rsResultServiceId: {
      type: String,
      default: () => null,
    },
    from: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    extras: {
      type: Array,
      default: () => [],
    },
    serviceType: {
      type: String,
      default: () => "",
    },
    value: {
      type: Array,
      default: () => [],
    },
    adults: {
      default: () => "",
    },
    children: {
      default: () => "",
    },
    infants: {
      default: () => "",
    },
    qty: {
      default: () => "1",
    },
    yearShift: {
      default: () => 0,
    },
  },
  components: { ItemExtrasListItem },
  data() {
    return {
      debug: false,
      selectedExtras: [...this.extras],
      extrasQuery: GET_AVAILABLE_EXTRAS_QUERY,
    };
  },

  computed: {
    maxPax() {
      return Number(this.adults) + Number(this.children);
    },
    itineraryDepartment() {
      return this.$store.getters.itineraryDepartment;
    },
    getExtras() {
      return this.serviceId != "" && this.from != "" && this.to != "";
    },
    extrasList() {
      const selectedExtras = [...this.selectedExtras];
      return this.availableExtras
        ? this.availableExtras.edges.map((item) => {
            const availExtra = { ...item.node };
            const selected = selectedExtras.find((e) => {
              //const key = e.id.includes(e.name) ? e.id : `${e.name}:::${e.id}`; //http://tracker.globetrack.ie/issues/6146
              const newExtraKey = e.id.includes(e.name)
                ? `${e.name}:::${e.id}`
                : e.id; //http://tracker.globetrack.ie/issues/6146
              const existingExtraKey = e.id.toString().split("_").pop();
              const keysToCheck = [newExtraKey, existingExtraKey];
              // console.log(
              //   "keysToCheck",
              //   keysToCheck,
              //   availExtra.id,
              //   keysToCheck.includes(availExtra.id)
              // );
              return keysToCheck.includes(availExtra.id);
            });
            //dirty fix - try using just name
            //console.log("selected", selected);
            // if (!selected) {
            //   selected = this.extras.find((e) => {
            //     //console.log(e.name, item.node.name, e.name == item.node.name);
            //     return e.name == item.node.name;
            //   });
            //   //update with proper id
            //   if (selected) {
            //     availExtra.id = selected.id;
            //   }
            // }
            //set selected extras params
            const returnItem = selected
              ? {
                  ...availExtra,
                  qty: availExtra.isMandatory
                    ? this.getPaxForMandatoryExtra(
                        availExtra,
                        this.adults,
                        this.children,
                        this.infants
                      )
                    : this.getPaxForExtra(selected),
                  startDate: selected.startDate,
                  endDate: selected.endDate,
                  isSelected: true,
                }
              : {
                  ...availExtra,
                  startDate: this.getStartDate(availExtra),
                  //endDate: this.to
                  endDate: this.getEndDate(availExtra),
                  qty: item.node.isMandatory
                    ? this.getPaxForMandatoryExtra(
                        item.node,
                        this.adults,
                        this.children,
                        this.infants
                      )
                    : 0,
                  isSelected: availExtra.isMandatory,
                };
            // console.log(
            //   "checking:",
            //   `${availExtra.id}`,
            //   "selected",
            //   selected,
            //   "returnItem",
            //   returnItem
            // );
            return returnItem;
          })
        : [];
    },
  },
  methods: {
    getStartDate(availExtra) {
      const validFrom = moment(availExtra.validFrom);
      const dateFrom = moment(this.from);
      const dateTo = moment(this.to);

      if (validFrom.isAfter(dateFrom)) {
        //check dateTo - https://tracker.globetrack.ie/issues/9530
        const dateTo = moment(this.to);
        if (validFrom.isBefore(dateTo)) {
          return availExtra.validFrom;
        } else {
          return this.serviceType &&
            this.serviceType == "ACCOMMODATION" &&
            !dateTo.isSame(dateFrom, "day")
            ? dateTo.subtract(1, "day").toISOString(true).split("T")[0]
            : this.to;
        }
        //return availExtra.validFrom;
      } else {
        //console.log("setting from", this.from);
        return this.from;
      }
    },
    getEndDate(availExtra) {
      const dateFrom = moment(this.from);
      const validTo = moment(availExtra.validTo);
      const dateTo = moment(this.to);
      if (validTo.isBefore(dateTo)) {
        return availExtra.validTo;
      } else {
        return this.serviceType &&
          this.serviceType == "ACCOMMODATION" &&
          !dateTo.isSame(dateFrom, "day")
          ? dateTo.subtract(1, "day").toISOString(true).split("T")[0]
          : this.to;
      }
    },
    getPaxForMandatoryExtra(extra, adults, children, infants) {
      if (extra.rateBase == "P") {
        if (extra.isChildOnly) {
          return Number(children);
        } else if (extra.isInfantOnly) {
          return Number(infants);
        } else {
          return Number(adults);
        }
      } else {
        return Number(this.qty);
      }
    },
    getPaxForExtra(extra) {
      if (extra.rateBase == "P") {
        if (extra.isChildOnly) {
          return Number(extra.children);
        } else if (extra.isInfantOnly) {
          return Number(extra.infants);
        } else {
          return Number(extra.adults);
        }
      } else {
        return Number(extra.qty);
      }
    },
    onSelect(event) {
      let eventKey = event.id.includes(event.name)
        ? `${event.name}:::${event.id}`
        : event.id; //http://tracker.globetrack.ie/issues/6146
      eventKey = eventKey.includes("_") ? eventKey.split("_").pop() : eventKey;
      const byNameEventKey = `${event.name}-${event.startDate.split("T")[0]}`; //-${event.endDate.split("T")[0]}`;
      const selected = this.availableExtras.edges.find(
        (e) => e.node.id == event.id
      );
      //adding info for custom priced extras

      if (selected) {
        event.buy = selected.node.buy;
        event.sell = selected.node.sell;
        event.currencyBuy = selected.node.currencyBuy;
        event.currencyBuyExchange = selected.node.currencyBuyExchange;
        event.currencySell = selected.node.currencyBuy;
        event.currencySellExchange = selected.node.currencySellExchange;
        event.isChildOnly = selected.node.isChildOnly;
        event.isInfantOnly = selected.node.isInfantOnly;
        event.isMandatory = selected.node.isMandatory;
        event.rateTypeCode = selected.node.rateTypeCode;
        event.rateBase = selected.node.rateBase;
        event.commission = selected.node.commission;
      }
      //set pax
      if (event.rateBase == "P") {
        if (event.isChildOnly) {
          event.children = event.qty;
          event.adults = 0;
          event.infant = 0;
        } else if (event.isInfantOnly) {
          event.infants = event.qty;
          event.adults = 0;
          event.children = 0;
        } else {
          event.adults = event.qty;
          event.children = 0;
          event.infants = 0;
        }
        event.qty = 1; //https://tracker.globetrack.ie/issues/8104
      } else {
        event.adults = 1;
        event.children = 0;
        event.infants = 0;
      }
      //merge with edited extra #8054 - for now, propably better to take it from the pricing info
      let editedExtra = {};
      if (this.extras.length > 0) {
        editedExtra = this.extras.find((e) => e.id == eventKey);
        if (!editedExtra) {
          //check for old itis https://tracker.globetrack.ie/issues/9445
          editedExtra = this.extras.find((e) => {
            const byNameKey = `${e.name}-${e.startDate.split("T")[0]}`; //--${e.endDate.split("T")[0]}`;
            return byNameKey == byNameEventKey;
          });
        }
      }
      this.selectedExtras = [
        ...this.selectedExtras.filter((e) => {
          let key = e.id.includes(e.name) ? `${e.name}:::${e.id}` : e.id; //http://tracker.globetrack.ie/issues/6146
          key = key.includes("_") ? key.split("_").pop() : key;
          //check the name for old itis https://tracker.globetrack.ie/issues/9445
          const byNameKey = `${e.name}-${e.startDate.split("T")[0]}`; //--${e.endDate.split("T")[0]}`;
          //console.log("filter", byNameKey, byNameEventKey);
          return key != eventKey && byNameKey != byNameEventKey;
        }),
        { ...editedExtra, ...event },
      ];
      this.$emit("on-selected-extras-change", [...this.selectedExtras]);
      this.$emit("input", [...this.selectedExtras]);
      //console.log("onSelect", this.selectedExtras);
    },
    onDeselect(event) {
      const eventKey = event.id.includes(event.name)
        ? `${event.name}:::${event.id}`
        : event.id; //http://tracker.globetrack.ie/issues/6146

      const selectedExtras = [
        ...this.selectedExtras.filter((e) => {
          let key = e.id.includes(e.name) ? `${e.name}:::${e.id}` : e.id; //http://tracker.globetrack.ie/issues/6146
          key = key.includes("_") ? key.split("_").pop() : key;
          //console.log(key, eventKey);
          return key != eventKey;
        }),
      ];
      this.$emit("on-selected-extras-change", [...selectedExtras]);
      this.$emit("input", [...selectedExtras]);
    },
  },
  watch: {
    extras(newExtras) {
      //console.log("newExtras", newExtras);
      this.selectedExtras = [...newExtras];
    },
    value(newExtras) {
      this.selectedExtras = [...newExtras];
    },
  },
  apollo: {
    availableExtras: {
      query: GET_AVAILABLE_EXTRAS_QUERY,
      variables() {
        return {
          serviceId: this.serviceId,
          rsResultServiceId: this.rsResultServiceId,
          startDate: this.from,
          endDate: this.to,
          agentId: this.$store.getters.itineraryAgentId,
          department: this.$store.getters.itineraryDepartment,

          yearShift:
            Number(this.yearShift) > 0
              ? Number(this.yearShift) * -1
              : Number(this.yearShift),
        };
      },
      skip() {
        return !this.getExtras;
      },
      fetchPolicy: "network-only",
      error(error) {
        //this.$emit("onLoadError", error.message);
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/ItemExtrasList.vue